var React = require("react");
const createReactClass = require('create-react-class');

var InputMixin = require("./FormInputMixin.jsx");

module.exports = createReactClass({
	mixins: [InputMixin],
	change: function() {
		this.setState({
			action: (typeof this.props.name !== 'undefined') ? "change" : "add",
			name: this.props.name,
			type: this.props.type,
			value: !(this.state.value)
		});

		// onChange props aren't triggered automatically, so if set through a component prop call it
		if (typeof this.props.onChange === "function") {
			this.props.onChange();
		}
	},
	render: function() {
		var className = 'checkbox';
		var alert;
		if (!this.state.isValid) {
			alert = (
				<div className='validation-message'>
					{this.state.serverError || this.props.validationError}
				</div>
			);
			className += ' validation-error';
		}
		return (
			<div>
				{alert}
				<input
					type="checkbox"
					className={className}
					name={this.props.name}
					id={this.props.name}
					checked={this.state.value}
					onChange={this.change}
					disabled={this.props.disabled}
				/>
				{this.props.label}
			</div>
		);
	}
});
